import {WorkingSureFlowLoop} from './working-sure-flow-loop';

export class SureFlowScheduleCreationInput {

  projectName!: string;
  locationCity!: string;
  locationState!: string;
  locationZip!: string;
  notes!: string;
  personId!: string;
  loops!: WorkingSureFlowLoop[];

}
